import { object, string } from 'yup';

import { validateYupTextField } from '../validateList';

export const loginValidationSchema = object().shape({
  email: validateYupTextField.email('invalidEmail').required('fillField'),
  password: string().required('fillField'),
});
